module.exports = __webpack_public_path__ + "img/slogo.aa1b043d.png";